<script setup lang="ts">
import confused from '@/assets/images/confused.png';
import { ArrowRightIcon } from '@heroicons/vue/20/solid';
</script>

<template>
    <div class="flex flex-col justify-center items-center h-full font-semibold">
        <img :src="confused" alt="confused" />
        <p class="text-3xl text-gray-900 leading-9 mb-2">Whoa! How did you end up here?</p>
        <p class="text-base text-gray-600 leading-6 font-normal">We couldn’t find the page you are looking for</p>
        <div class="flex justify-between gap-4 mt-8">
            <router-link to="/" class="px-3.5 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white shadow-sm rounded-sm"> Go back to the homepage </router-link>

            <a href="mailto:ishveer@emailmeter.com" class="px-3.5 py-2.5 flex gap-[6px] text-gray-500 hover:text-gray-600 items-center"> Contact support <ArrowRightIcon class="w-5 h-5" /> </a>
        </div>
    </div>
</template>
